import { Ability } from '@casl/ability'
import { initialAbility } from './initialAbility'
import { getUserData } from '../../utility/Utils'

//  Read ability from localStorage
// * Handles auto fetching previous abilities if already logged in user
// ? You can update this if you store user abilities to more secure place
// ! Anyone can update localStorage so be careful and please update this
const userData = getUserData()
const existingAbility = userData ? userData.ability : null

// Criar uma ability customizada que sempre permite acesso para admins
const customAbility = new Ability(existingAbility || initialAbility)

// Sobrescrever o método can para permitir acesso total para admins
const originalCan = customAbility.can.bind(customAbility)
customAbility.can = function(action, resource) {
  try {
    // Verificar se o usuário é admin
    const userData = getUserData()
    const isAdmin = userData?.profile_id === 2 || userData?.profile_id === 3
    
    // Se for admin, sempre permitir
    if (isAdmin) {
      return true
    }
    
    // Caso contrário, usar a verificação original
    return originalCan(action, resource)
  } catch (error) {
    console.warn('Erro ao verificar permissões:', error)
    return originalCan(action, resource)
  }
}

export default customAbility
